var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosePopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 2.013L15.988.25 9 7.237 2.013.25.25 2.013 7.237 9 .25 15.988l1.763 1.762L9 10.762l6.988 6.988 1.762-1.762L10.762 9l6.988-6.987z",
    fill: "#1D426D",
    fillOpacity: 0.6
  })));
}

export default SvgClosePopup;